<template>
  <div class="record-helper">
    <span class="text-muted form-text" :class="marginClass">
      {{ text }}
      <a :href="`tel:${storeGlobalConfig.telHref}`">{{ storeGlobalConfig.tel }}</a>
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'RecordHelper',
  props: {
    text: {
      type: String,
      default: 'Если что-то не получается, позвоните по номеру'
    },
    marginClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      storeGlobalConfig: 'getGlobalConfig',
    })
  }
}
</script>

<style lang="scss" scoped>
.record-helper {
  display: flex;
  justify-content: center;
  text-align: center;

  span {
    font-family: 'Manrope Regular', serif;
    font-size: 13px;

    @media (max-width: 768px) {
      a {
        display: block;
        margin-top: 7px;
        font-size: 14px;
      }
    }
  }
}
</style>